import React from 'react';
import Table from './Table';
import { setDateTime } from '../utils';

const GroupTables = ({
  groupData,
  numbersPayments,
  paymentDays,
  promotor,
  fecha,
  requisition,
  letter,
}) => {
  const isBigGroup = requisition?.Grupo?.Socios?.length >= 8;
  const isAnIndividualCredit = requisition?.Grupo?.Socios?.length === 1;

  return (
    <div
      style={{
        ...styles.fontSize,
        ...(!isAnIndividualCredit && styles.contentTables),
        ...(!isAnIndividualCredit && {
          ...(isBigGroup
            ? {
                height: `${letter.HEIGHT / (groupData.length === 2 ? 1 : 2)}cm`,
              }
            : { height: `${letter.HEIGHT / 4}cm` }),
        }),
      }}
      className={`w-100`}
    >
      {groupData?.map((amounts, indexAmount) => (
        <div
          style={{
            position: 'relative',
            height:
              (groupData.length === 2 && '50%') ||
              (groupData.length === 1 && '100%'),
          }}
          key={`group-data-${indexAmount}`}
        >
          <Table
            style={
              !isAnIndividualCredit
                ? {
                    position: 'absolute',
                    top: '50%',
                    transform: 'translateY(-50%)',
                  }
                : {
                    // margin: '3rem auto',
                  }
            }
            id={`table-payment-control-${indexAmount}`}
            index={indexAmount + 1}
            newNumWeekArray={numbersPayments[indexAmount]}
            paymentDays={paymentDays[indexAmount]}
            amounts={amounts}
            promoter={promotor}
            elaborationDate={setDateTime(fecha, indexAmount, requisition)}
            requisition={requisition}
          />
        </div>
      ))}
    </div>
  );
};

export default GroupTables;

const styles = {
  docSection: {
    paddingTop: 0,
    paddingBottom: 0,
  },
  fontSize: {
    fontSize: '7pt',
  },
  title: {
    fontSize: '2rem',
    fontWeight: 500,
    lineHeight: 1.2,
  },
  contentTables: {
    paddingTop: '3rem',
    paddingBottom: '3rem',
  },
};
